import { StdResponse, request } from "@/global/config/request";
import { DataBox } from "@/global/interface/device/data-box";
import { DeviceCollectionHistory, DeviceInstallHistory, DeviceModelingDetail, DeviceTestConnectHistory } from "@/global/interface/device/sensor";
import qs from "qs";


export function getDataBoxes(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/project/${projectId}/data-boxes`, {
        params: {
            ...params,
        }
    })
}

export function getDataBoxesByTypes(projectId: number, types: number[], params?: {}): Promise<StdResponse<any>> {
    return request.get(`/project/${projectId}/data-boxes/types`, {
        params: {
            types: types,
            ...params
        },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

export function getDataBoxDetail(id: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/data-boxes/${id}`, {
        params: {
            ...params,
        }
    })
}

export function createDataBox(data: DataBox, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/data-boxes`, data, {
        params: {
            ...params,
        }
    })
}

export function createDataBoxes(data: DataBox[], params?: {}): Promise<StdResponse<any>> {
    return request.post(`/data-boxes/multi`, data, {
        params: {
            ...params,
        }
    })
}

export function updateDataBox(id: number, data: DataBox, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/data-boxes/${id}`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteDataBoxByPrimitiveUuid(primitiveUuid: string, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/primitives/${primitiveUuid}/delete-data-box`, {
        params: {
            ...params,
        }
    })
}

export function deleteDataBox(id: number, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/data-boxes/${id}`, {
        params: {
            ...params,
        }
    })
}

export function deleteDataBoxes(data: number[], params?: {}): Promise<StdResponse<any>> {
    return request.post(`/data-boxes/delete-multi`, data, {
        params: {
            ...params,
        }
    })
}

export function getDataBoxByPrimitiveUuid(primitiveUuid: string, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/primitives/${primitiveUuid}/data-boxes`, {
        params: {
            ...params,
        }
    })
}

export function getDataBoxInstallByDataBoxId(dataBoxId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/data-boxs/${dataBoxId}/installs`, {
        params: {
            ...params,
        },
    })
}

export function addDataBoxInstallHistory(projectId: number, dataBoxId: number, data: DeviceInstallHistory, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/projects/${projectId}/data-boxs/${dataBoxId}/installs`, data, {
        params: {
            ...params,
        },
    })
}

export function findModelingDetailByDataBoxId(dataBoxId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/data-boxs/${dataBoxId}/modeling`, {
        params: {
            ...params,
        },
    })
}

export function addDataBoxModelingDetail(projectId: number, dataBoxId: number, data: DeviceModelingDetail, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/projects/${projectId}/data-boxs/${dataBoxId}/modeling`, data, {
        params: {
            ...params,
        },
    })
}

export function getDataBoxTestByDataBoxId(dataBoxId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/data-boxs/${dataBoxId}/test`, {
        params: {
            ...params,
        },
    })
}

export function addDataBoxTestHistory(projectId: number, dataBoxId: number, data: DeviceTestConnectHistory, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/projects/${projectId}/data-boxs/${dataBoxId}/test`, data, {
        params: {
            ...params,
        },
    })
}

export function addDataBoxCollectionHistory(projectId: number, dataBoxId: number, data: DeviceCollectionHistory, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/projects/${projectId}/data-boxs/${dataBoxId}/collection`, data, {
        params: {
            ...params,
        },
    })
}

export function getDataBoxCollectionByDataBoxId(dataBoxId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/data-boxs/${dataBoxId}/collection`, {
        params: {
            ...params,
        },
    })
}

export function dataBoxSyncIPC(dataBoxId: number, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/data-boxs/${dataBoxId}/sync-ipc`, {
        params: {
            ...params,
        },
    })
}

export function startOnceTest(dataBoxId: number, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/data-boxs/${dataBoxId}/test-ipc`, {}, {
        params: {
            ...params,
        },
    })
}